import "./CustomerView.scss";
import React, { useState, useEffect } from "react";
import request from "request";

import Modal from "Modal";
import Input from "Input";
import Button from "Button";

const CustomerView = ({ order, clearOrder, updateTab, isCustomerActive, setIsCustomerActive }) => {
  // customer contains the form with the user's input
  const [customer, setCustomer] = useState({ name: "", phone: "", email: "" });
  // customerId contains the customer from the server if the user choose to select a suggestion from the server
  const [customerId, setCustomerId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState([]);

  const fetchSuggestions = (query) => {
    if (!query) {
      setSuggestions([]);
      return;
    }

    setIsLoading(true);
    request
      .get("customers", { params: {all: true, search: query } })
      .then(({ data }) => {
        setSuggestions(data.pageData || []);
        setIsLoading(false);
      })
      .catch(() => {
        setSuggestions([]);
        setIsLoading(false);
      });
  };

  const handleInputChange = (field, value) => {
    setCustomer({ ...customer, [field]: value });

    if (field === "name" || field === "phone" || field === "email") {
      fetchSuggestions(value);
    }
  };

  const handleSuggestionClick = (suggestedCustomer) => {
    setCustomer(suggestedCustomer);
    setCustomerId(suggestedCustomer.id)
    setSuggestions([]);
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    // customerId comes either from state - when the user chooses a suggestion
    // or from this method, when we create a new customer
    let newCustomerId = customerId;
    setErrors([])
    // customerId can be loaded from the server using search suggestions
    // create a new customer unless the user have selected a search suggestionq
    if( !customerId ) {
      // this uses api/customer/customers#create controller#action
      await request.post(`/customers`, {customer: customer}).then(({data}) => {
        if (data.success) {
          // we don't really need to set the state here, we can use a variable for customerID
          // however maybe I will use it later
          newCustomerId  = data.customer.id
          //setCustomerId(data.customer.id)

        } else {
          setErrors(data.errors);
          setIsSubmitting(false);
        }
      }).catch((e) => {
        e.response?.data?.errors && setErrors(e.response.data.errors);
        setIsSubmitting(false);
      });
    }
    if (newCustomerId) {
      await request.post(`/orders/${order.id}/put_on_tab`, { customer_id: newCustomerId }).then(({data}) => {
        clearModal();
        // We have successfully put the order on tab, now clear the (current) order view
        clearOrder();
        updateTab();
      })
    }
  };

  const clearModal = () => {
    setCustomer({ name: "", phone: "", email: "" });
    setCustomerId(null)
    setSuggestions([]);
    setIsCustomerActive(false);
    setIsSubmitting(false);
  };

  const renderModalActions = () => {
    return (
      <div className="is-flex is-flex-grow-1">
        <Button
          onClick={clearModal}
          text="Cancel"
          className="is-outlined"
          color="red"
        />
        <Button
          text="Create Customer"
          loading={isSubmitting}
          disabled={!(customer.name || customer.phone || customer.email)}
          onClick={handleSubmit}
          color="green"
          className="is-text-weight-bold ml-auto"
        />
      </div>
    );
  };

  const renderErrors = () => {
    if (errors && errors.length > 0) {
      return (
        <div className="notification is-danger">
          <ul>
            {errors.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </div>
      );
    }
    return null;
  };

  const renderSuggestions = () => {
    if (suggestions.length > 0) {
      return (
        <div>
          <hr />
          <h5>Select existing Customer</h5>
          <div className="suggestions-box">
            <ul>
              {suggestions.map((suggestion, index) => (
                <li
                  key={index}
                  className="suggestion-item"
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  {suggestion.name} - {suggestion.phone} - {suggestion.email}
                </li>
              ))}
            </ul>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="CustomerView">
      <Modal
        open={!!isCustomerActive}
        toggleModal={clearModal}
        actions={renderModalActions()}
      >
        <div>
          <h3 className="title">Create Customer</h3>

          {renderErrors()}

          <div className="field">
            <label className="label">Name</label>
            <Input
              value={customer.name}
              onChange={(e) => handleInputChange("name", e)}
              placeholder="Enter customer name"
            />
          </div>
          <div className="field">
            <label className="label">Phone</label>
            <Input
              value={customer.phone}
              onChange={(e) => handleInputChange("phone", e)}
              placeholder="Enter customer phone"
            />
          </div>
          <div className="field">
            <label className="label">Email</label>
            <Input
              value={customer.email}
              onChange={(e) => handleInputChange("email", e)}
              placeholder="Enter customer email"
            />
          </div>

          {renderSuggestions()}
        </div>
      </Modal>
    </div>
  );
};

export default CustomerView;
